export function foldImages(content) {
  const images = new Map();
  let number = 0;
  const keep = original => { let label; do { label = `【圖片 ${++number}】`; } while (content.includes(label)); images.set(label, original); return label; };
  const text = content.replace(/!\[[^\]\n]*\]\(data:image\/[\w.+-]+;base64,[A-Za-z0-9+/=]+\)/g, keep)
    .replace(/data:image\/[\w.+-]+;base64,[A-Za-z0-9+/=]+/g, keep);
  return { text, images };
}
export function unfoldImages(content, images) {
  for (const [label, original] of images) content = content.replaceAll(label, original);
  return content;
}
